module.exports = __webpack_public_path__ + "static/media/bg-lappi.f2eae99c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/bg-lappi.jpg
// module id = 1088
// module chunks = 21